import "./Codequest.css";
import "./Csedept.css";
import { Backtotop, Floatinmenu, Underline } from "../../widgets";
import { RadialMenu } from "../../components";
import { TopPerformerCard } from "../../components";
import { FaComputer } from "react-icons/fa6";
import { cse_dept_menu } from "../../constants/cse_dept";
import Gallery from "../../components/Gallery/Gallery";

const cse_asso_logo =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/CSE_ASSO_LOGO.webp";
const codequest_img =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/Codequest-img.webp";
const codequest_gallery_1 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/CODE_QUEST_GALLERY_1.webp";
const codequest_gallery_2 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/CODE_QUEST_GALLERY_4.webp";
const codequest_gallery_3 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/CODE_QUEST_GALLERY_3.webp";
const codequest_gallery_4 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/CODE_QUEST_GALLERY_2.webp";
const codequest_gallery_5 =
"https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/codequest6.webp";

const codequest_gallery_6 =
"https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/codequest5.webp";
const madasamy_code_master =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/MADASAMY_CODE_MASTER.webp";
const thamarai_code_knight =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/THAMARAI_CODE_KNIGHT.webp";

export default function Codequest() {
  const codeQuestImages = [
    codequest_gallery_1,
    codequest_gallery_2,
    codequest_gallery_3,
    codequest_gallery_4,
    codequest_gallery_5,
    codequest_gallery_6,
  ];

  return (
    <>
      <div className="csedept">
        <div className="csebg">
          <div className="cseheading">
            Department of Computer Science and Engineering
          </div>
          <div className="cse_sub_heading">CODE-QUEST</div>
        </div>

        <section className="csedark">
          <div className="dept_float_menu">
            <Floatinmenu logo={FaComputer} head="Menu" links={cse_dept_menu} />
          </div>

          <RadialMenu menu_links={cse_dept_menu} />

          <div className="cse_lab_area">
            <Underline heading="What is CodeQuest?" />

            <div className="csetwo-col">
              <p className="cse_dept_content">
                CodeQuest is an innovative coding competition designed to
                challenge and inspire students in computer science. This
                competition aims to foster a spirit of innovation and creativity
                among participants, encouraging them to push the boundaries of
                their coding skills. Through a series of challenging tasks and
                problem-solving exercises, CodeQuest provides a platform for
                students to showcase their coding prowess and compete against
                their peers.
              </p>

              <div className="dept_img_holder">
                <img
                  className="Codequest_img"
                  src={codequest_img}
                  alt="CodeQuest"
                />
              </div>
            </div>
            <Underline heading="Organized by CSE Association" />
            <div className="codequest-organizer">
              <div className="organizer-logo">
                <img src={cse_asso_logo} alt="CSE Association Logo" />
              </div>
              <div className="organizer-description">
                <p>
                  CodeQuest is proudly conducted by the{" "}
                  <strong>CSE Association</strong> of ACGCET. The association is
                  committed to cultivating technical excellence, collaborative
                  learning, and innovation among students. This competition is
                  one of its key initiatives to empower aspiring coders and
                  encourage a culture of problem-solving.
                </p>
              </div>
            </div>

            <Underline heading="Top Performers of the Year - 2025" />
            <div className="Codequest-top-performer">
              <TopPerformerCard
                title="CODE MASTER"
                image={madasamy_code_master}
                name="MADASAMY I"
              />
              <TopPerformerCard
                title="CODE KNIGHT"
                image={thamarai_code_knight}
                name="THAMARAI NAGASAMY K"
              />
            </div>
            <Underline heading="Gallery Highlights" />
            <div className="codequest_gallery">
              <Gallery images={codeQuestImages} title="CodeQuest Moments" />
            </div>
          </div>
        </section>

        <Backtotop />
      </div>
    </>
  );
}
